import { useMutation } from "@tanstack/react-query";

import getTbiApi from "@/api/api-v1";
import { useInvalidateUserQueries } from "@/queries/query-users";
import { useOnError } from "@/utils/on-error";

export function useCreateUser() {
  const invalidateUserQueries = useInvalidateUserQueries();
  const onError = useOnError("Gebruiker maken mislukt.");
  return useMutation({
    mutationFn: async (accessRule: { email: string; hasWriteAccess: boolean }) => {
      const { id } = await getTbiApi().UsersApi.usersCreate({
        accessRule,
      });
      invalidateUserQueries(id);
    },
    onError,
  });
}
